module.exports = __webpack_public_path__ + "img/line-comparison_1g.f5b89f4e.png";